import React from 'react';
import DiagramCanvas from '../diagram/DiagramCanvas';
import { parseDiagram } from '../diagram/types';
import type { TrainingPlanItem } from '../../types/trainingSession';

/** A blokk rajzának előnézete; ha a tárolt ábra nem olvasható, nem jelenik meg semmi. */
export const DiagramPreview: React.FC<{ json?: string | null; title: string }> = ({ json, title }) => {
  const diagram = parseDiagram(json);
  if (!diagram) return null;
  return <DiagramCanvas diagram={diagram} title={title} className="w-full h-auto rounded-md" />;
};

/** Egy edzésterv (cél + blokkok) csak olvasható nézete. */
const PlanView: React.FC<{ goal?: string | null; items: TrainingPlanItem[] }> = ({ goal, items }) => (
  <div className="space-y-3">
    {goal && (
      <p className="text-sm text-gray-800">
        <span className="font-medium">Cél: </span>
        {goal}
      </p>
    )}
    {items.length > 0 && (
      <ol className="space-y-2">
        {items.map((item, index) => (
          <li key={index} className="bg-white rounded-md border border-gray-200 px-3 py-2">
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-sm font-medium text-gray-900">
                {index + 1}. {item.title}
              </span>
              {item.durationMinutes ? <span className="shrink-0 text-xs text-gray-500">{item.durationMinutes} perc</span> : null}
            </div>
            {item.description && <p className="mt-1 text-sm text-gray-600 whitespace-pre-line">{item.description}</p>}
            {item.diagram && (
              <div className="mt-2 max-w-xl">
                <DiagramPreview json={item.diagram} title={item.title} />
              </div>
            )}
          </li>
        ))}
      </ol>
    )}
  </div>
);

export default PlanView;
